module.exports = __webpack_public_path__ + "static/zdjęcia3-2d909adcd735727ccdb2d4eaed0e5342.svg";